import { Tab, Tabs } from "react-bootstrap";
import Antt from "./Antt";
import VeicTracao from "./VeicTracao";
import LacresRodoviario from "./LacresRodoviario";
import Reboques from "./Reboques";

export default function Rodoviario() {
    return (<>
        <Tabs defaultActiveKey="rodo_veictracao" id="tab-rodoviario" className="mb-2">
            <Tab eventKey="rodo_veictracao" title="Veículo de Tração">
                <VeicTracao />
            </Tab>

            <Tab eventKey="rodo_reboque" title="Reboques" className="px-2">
                <Reboques />
            </Tab>

            <Tab eventKey="rodo_antt" title="ANTT" className="px-2">
                <Antt />
            </Tab>

            <Tab eventKey="rodo_lacre" title="Lacres" className="px-2">
                <LacresRodoviario />
            </Tab>
            
        </Tabs>
   </> )
}